import { useEffect } from "react";

import { useStoreActions, useStoreState } from "store/store";

export const useSyncStoreData = () => {
  // actions
  const setIsLocationAirport = useStoreActions((a) => a.setIsLocationAirport);
  const setIsDestinationAirport = useStoreActions(
    (a) => a.setIsDestinationAirport
  );
  // state
  const isCustomDestination = useStoreState((s) => s.isCustomDestination);
  const cart = useStoreState((s) => s.cart);

  useEffect(() => {
    if (isCustomDestination) {
      setIsLocationAirport(false);
      setIsDestinationAirport(false);
      return;
    }

    if (Number(cart?.location?.is_airport)) {
      setIsLocationAirport(true);
    } else {
      setIsLocationAirport(false);
    }

    if (Number(cart?.destination?.is_airport)) {
      setIsDestinationAirport(true);
    } else {
      setIsDestinationAirport(false);
    }
  }, [isCustomDestination, cart]);
};
